import { render } from "./MiniCart.vue?vue&type=template&id=1292900e&ts=true"
import script from "./MiniCart.vue?vue&type=script&lang=ts"
export * from "./MiniCart.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__